import React, { useEffect, useState } from 'react';
import { Header, Button } from '@/components';
import { styled } from '@mui/material';
import t from '@/utils/translate';

const Main = styled('main')(`
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 24px;
`);

const Form = styled('form')(`
  margin: auto;
  width: 30%;
  min-width: 200px;
  max-width: 420px;
`);

let lastLocation: string;

export default () => {
  const [delay, setDelay] = useState(10);

  useEffect(() => {
    lastLocation = location.href;
  }, []);

  useEffect(() => {
    window.setTimeout(() => {
      if (delay === 1) {
        location.assign(lastLocation);
      } else {
        setDelay(delay - 1);
      }
    }, 1000);
  }, [ delay ]);
  
  return (
    <>
      <Header/>
      <Main>
        <Form onSubmit={(e) => {
          e.preventDefault();
          location.assign(lastLocation);
        }}>
          {t('common.message.staleClient', { delay }, true)}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            color="primary"
            size="large"
          >
            {t('action.reload')}
          </Button>
        </Form>
      </Main>
    </>
  );
}